let list = [];
let seq = 0;
const subs = new Set();
const timers = {};
const emit = () => subs.forEach((f) => f(list));

export function subscribe(f) { subs.add(f); f(list); return () => subs.delete(f); }

function arm(t, ms) { clearTimeout(timers[t.id]); t.until = Date.now() + ms; timers[t.id] = setTimeout(() => dismiss(t.id), ms); }

export function dismiss(id) {
  clearTimeout(timers[id]);
  delete timers[id];
  list = list.filter((x) => x.id !== id);
  emit();
}

export function toast(text, undo) {
  if (!text) return;
  const t = { id: ++seq, text, undo };
  list = [...list, t];
  const undos = list.filter((x) => x.undo), plain = list.filter((x) => !x.undo);
  if (undos.length > 3) dismiss(undos[0].id);
  if (plain.length > 2) dismiss(plain[0].id);
  arm(t, undo ? 10000 : 3200);
  emit();
}

export function hold(id) {
  const t = list.find((x) => x.id === id);
  if (!t) return;
  clearTimeout(timers[id]);
  t.left = Math.max(0, t.until - Date.now());
}

export function release(id) {
  const t = list.find((x) => x.id === id);
  if (t) arm(t, Math.max(2000, t.left ?? 2000));
}

export function runNewestUndo() {
  const t = [...list].reverse().find((x) => x.undo);
  if (!t) return false;
  dismiss(t.id);
  t.undo();
  return true;
}
